export class WriteReview {
  constructor(public hash?: string,
              public url?: string,
              public targetUrl?: string,
              public targetParams?: {
                user: string,
                submission: string,
                campaign: string
              }) {
    this.targetParams = {
      user: '',
      submission: '',
      campaign: ''
    };
  }
}

export let BRAND_PATH = {
  'cw': '/candlewood',
  'cp': '/crowneplaza',
  'vn': '/evenhotels',
  'hi': '/holidayinn',
  'cv': '/holidayinnclubvacations',
  'ex': '/holidayinnexpress',
  'rx': '/holidayinnresorts',
  'in': '/hotelindigo',
  'ul': '/hualuxe',
  'ic': '/intercontinental',
  'ki': '/kimptonhotels',
  'rc': '/rewardsclub',
  'sb': '/staybridge',
  'va': '/avidhotels',
  're': '/regent',
  'vx': '/voco'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/write-review/write-review/write-review-model.ts